import React, {ChangeEvent} from 'react';
import {Input, InputNumber, Select} from 'antd';
import {CheckJobFilterType} from '../graphql/types/BcpCheckJobTypes';

interface BcpCheckJobFilterProps {
    filters: CheckJobFilterType;
    setFilters: (filters: CheckJobFilterType) => void;
    userGroupOptions?: {label: string; value: number}[];
}

const statusOptions = [
    {label: '全部', value: undefined},
    {label: '启用', value: 1},
    {label: '未启用', value: 0},
];

const BcpCheckJobFilter: React.FC<BcpCheckJobFilterProps> = ({filters, setFilters, userGroupOptions}) => {
    return (
        <div className="mb-4">
            <div className="grid grid-cols-3 gap-x-4 gap-y-3 mb-4">
                <div className="flex items-center">
                    <span className="w-[5em] flex-shrink-0 text-right pr-2">任务ID</span>
                    <InputNumber
                        className="w-full"
                        value={filters.id}
                        onChange={(v) => setFilters({...filters, id: v ?? undefined})}
                        placeholder="请输入任务ID"
                        min={0}
                    />
                </div>
                <div className="flex items-center">
                    <span className="w-[5em] flex-shrink-0 text-right pr-2">任务名称</span>
                    <Input
                        value={filters.name || ''}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            setFilters({...filters, name: e.target.value || undefined})
                        }
                        placeholder="请输入任务名称"
                        allowClear
                    />
                </div>
                <div className="flex items-center">
                    <span className="w-[5em] flex-shrink-0 text-right pr-2">创建人</span>
                    <Input
                        value={filters.createUser || ''}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            setFilters({...filters, createUser: e.target.value || undefined})
                        }
                        placeholder="请输入创建人"
                        allowClear
                    />
                </div>
                <div className="flex items-center">
                    <span className="w-[4em] flex-shrink-0 text-right pr-2">状态</span>
                    <Select
                        className="w-full"
                        value={filters.status}
                        onChange={(value) => setFilters({...filters, status: value})}
                        options={statusOptions}
                        placeholder="全部"
                        allowClear
                    />
                </div>
                <div className="flex items-center">
                    <span className="w-[5em] flex-shrink-0 text-right pr-2">用户组</span>
                    <Select
                        className="w-full"
                        value={filters.userGroupId}
                        onChange={(value) => setFilters({...filters, userGroupId: value})}
                        options={userGroupOptions}
                        placeholder="全部"
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                            (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default BcpCheckJobFilter;
